if (window.location.hash) {
  history.replaceState(null, '', window.location.pathname);
}
window.scrollTo({ top: 0, behavior: 'instant' });

window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    window.scrollTo({ top: 0, behavior: 'instant' });
    history.replaceState(null, '', window.location.pathname);
  }
});


const revealItems = [
  ...document.querySelectorAll(
    'header, .montain, .hero, .menu, .projections, .communication, footer'
  )
];

revealItems.forEach((el) => {
  el.style.opacity = '0';
});

revealItems.forEach((el, i) => {
  setTimeout(() => {
    el.style.opacity = '';
    el.classList.add('page-reveal');
  }, i * 120);
});


document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener('click', (e) => {
    const targetId = link.getAttribute('href').slice(1);
    const target = document.getElementById(targetId);
    if (!target) return;
    e.preventDefault();
    const headerHeight = document.querySelector('header')?.offsetHeight ?? 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
    history.pushState(null, '', `#${targetId}`);
  });
});


const newsletterForm = document.querySelector('.com-newsletter-sub');
const newsletterButton = document.querySelector('.com-newsletter-sub-button');
const newsletterInput = document.querySelector('.com-newsletter-sub-email');
const buttonText = document.querySelector('.com-newsletter-sub-button-text');

if (newsletterForm) {
  newsletterForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = newsletterInput?.value?.trim();
    if (!email) return;

    if (buttonText) buttonText.textContent = '…';
    if (newsletterButton) newsletterButton.disabled = true;

    try {
      await new Promise((r) => setTimeout(r, 600)); // simulation

      if (buttonText) buttonText.textContent = '✓ Inscrit·e';
      if (newsletterInput) {
        newsletterInput.value = '';
        newsletterInput.disabled = true;
      }

    } catch {
      if (buttonText) buttonText.textContent = 'Erreur';
      setTimeout(() => {
        if (buttonText) buttonText.textContent = 'Inscription';
        if (newsletterButton) newsletterButton.disabled = false;
      }, 2000);
    }
  });
}